// src/pages/PayFail.tsx
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, CircleAlert } from "lucide-react";
import "../styles/payment-design.css";

export default function PayFail() {
  const location = useLocation();
  const errorMsg = location.state?.error ?? "이용목록에서 결제 상태를 확인해 주세요.";

  return (
    <div className="jp-payment-result jp-payment-result-fail">
      <section className="jp-payment-result-card">
      <span className="jp-payment-result-icon"><CircleAlert size={28} /></span>
      <span className="jp-payment-eyebrow">JULYUPAY · 결제 결과</span>
      <h1>결제를 완료하지 못했어요</h1>
      <p role="alert">{errorMsg}</p>
      <div className="jp-payment-result-actions">
        <Link
          to="/pay"
          className="jp-payment-result-primary"
        >
          이용목록 확인 <ArrowRight size={17} />
        </Link>
        <Link
          to="/support"
          className="jp-payment-result-secondary"
        >
          고객센터
        </Link>
      </div>
      </section>
    </div>
  );
}
